<mat-card class="example-card">
  <mat-card-header class="card-header">
    <mat-card-title class="card-titulo">{{'Gasto' | translate}} desde Documento</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content style="margin-bottom: 0%;">

    <mat-label class="text-style" *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label class="text-style" *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label class="text-style" *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>

    <div *ngIf="!isValidating">

      <!-- OPERACION DEL GASTO -->
      <div *ngIf="canEditComunidad && canEditUf" fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center" style="margin-bottom: 10px;">

        <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="text-align: center; margin-bottom: 8px;">
          <mat-label style="font-weight: bold; font-size: 16px;">¿A qué le vas a cargar un gasto?</mat-label>
        </div>
        <br />
        <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="text-align: center;">
          <button mat-raised-button (click)="loadComunidadView()"  [disabled]="isProcessing()"
            class="zb-button" [ngStyle]="{ 'background-color': esGastoComunidad === true ? '#ffd000' : '#fff'}">A
            {{('Comunidad' | translate).toLowerCase()}}</button>
          <button mat-raised-button (click)="loadUfView()"  [disabled]="isProcessing()" class="zb-button"
            [ngStyle]="{ 'background-color': esGastoUf === true ? '#ffd000' : '#fff'}">A {{('UnidadFuncional' | translate).toLowerCase()}}</button>
        </div>

        <hr style="margin: 10px 0px; width: 100%;">

      </div>

      <!-- SELECCION DE COMUNIDAD / UF -->
      <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="esGastoComunidad || esGastoUf">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon style="margin-top: -3px; margin-right: 5px;">business</mat-icon> Selecciona una {{('Comunidad' | translate).toLowerCase()}} a la cual le cargarás los gastos:
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div fxLayout="row stretch" class="zb-readonly" fxLayoutAlign="center center">

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorComunidad()?.length > 0 ? '-25px' : '0px')}">
              <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}*</mat-label>
              <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
              <mat-select [(ngModel)]="item.ComunidadId" (selectionChange)="onComunidadSelect()">
                <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorComunidad()?.length > 0">
              {{ getErrorComunidad() }}
            </mat-label>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          </div>

        </div>

      </mat-expansion-panel>

      <br/>

      <!-- LISTADO DE GASTOS A ADJUNTAR -->
      <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;" *ngIf="item?.ComunidadId != null && item?.ComunidadId > 0">

        <mat-expansion-panel-header>
          <mat-panel-title class="card-subtitulo">
            <mat-icon style="margin-top: -3px;">playlist_add_check</mat-icon> Listado de Gastos Analizados
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div fxLayout="row stretch" fxLayout.xs="column">
          <mat-label style="font-weight: bold;">A continuación, adjunta todos los archivos que queres que sean analizados y convertidos en gastos:</mat-label>
        </div>

        <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 5px;">

          <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin-top: 10px;">
            <button mat-icon-button matSuffix (click)="adjuntoInput.click()" [disabled]="isFileAttaching">
              <mat-icon style="margin-right: 5px;">attach_file</mat-icon> Agregar adjuntos
            </button>
            <input hidden (change)="onNewFileAttach($event)" #adjuntoInput type="file" multiple>
            <mat-label *ngIf="isFileAttaching"><br /><i class="fa fa-spinner fa-spin"></i> Subiendo archivo...</mat-label>
          </div>

        </div>

        <div fxLayout="row stretch" fxLayout.xs="column" *ngFor="let file of item.Adjuntos" style="margin: 5px;">

          <mat-expansion-panel [expanded]="true" hideToggle="false" style="width: 100%;">

            <mat-expansion-panel-header>
              <mat-panel-title class="card-subtitulo">
                <div fxFlex=5 fxFlex.xs=5 class="flex-item" style="margin-right: 8px;">
                  <button mat-icon-button (click)="onFileAttachedDelete(file)" title="Eliminar adjunto">
                    <i class="fa fa-trash fa-1x"></i>
                  </button>
                </div>
                <div fxFlex=95 fxFlex.xs=95 class="flex-item" style="margin-top: 10px;">
                  <b style="margin-right: 3px;"><u>Archivo</u>:</b> <a matLine href="{{file.UrlDocumento}}" target="_blank">{{file.NombreDocumento}}</a>
                </div>
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <ng-container *ngIf="hasAnalyzed">

              <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!file.Success">
                <mat-label style="font-weight: bold;">Ocurrió un error analizando: {{file.MensajeError}}</mat-label>
              </div>

              <ng-container *ngIf="file.Success">

                <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="esGastoUf">

                  <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorUnidadFuncionalId(file)?.length > 0 ? '-25px' : '0px')}">
                      <mat-label *ngIf="!isUnidadFuncionalSearching">{{'UnidadFuncional' | translate}}*</mat-label>
                      <mat-label *ngIf="isUnidadFuncionalSearching">Cargando...</mat-label>
                      <mat-select [(ngModel)]="file.UnidadFuncionalId">
                        <mat-option *ngFor="let s of unidadFuncionalList" [value]="s.Id">{{s.Codigo}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorUnidadFuncionalId(file)?.length > 0">
                      {{ getErrorUnidadFuncionalId(file) }}
                    </mat-label>
                  </div>

                </div>

                <div fxLayout="row stretch" fxLayout.xs="column">

                  <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorFechaGasto(file)?.length > 0 ? '-25px' : '0px')}">
                      <mat-label [ngStyle]="{'color': (getErrorFechaGasto(file)?.length > 0 ? '#E53935' : 'auto')}">Fecha de Gasto*</mat-label>
                      <input matInput [matDatepicker]="fechaGastoPicker" [(ngModel)]="file.FechaGasto" (click)="fechaGastoPicker.open()">
                      <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaGastoPicker">
                      </mat-datepicker-toggle>
                      <mat-datepicker #fechaGastoPicker></mat-datepicker>
                    </mat-form-field>
                    <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorFechaGasto(file)?.length > 0">
                      {{ getErrorFechaGasto(file) }}
                    </mat-label>
                  </div>
                  <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorTipoGastoId(file)?.length > 0 ? '-25px' : '0px')}">
                      <mat-label *ngIf="!isTipoGastoComunidadSearching">Tipo de Gasto*</mat-label>
                      <mat-label *ngIf="isTipoGastoComunidadSearching">Cargando...</mat-label>
                      <mat-select [(ngModel)]="file.TipoGastoId" (selectionChange)="onTipoGastoComunidadSelect(file)">
                        <mat-option *ngFor="let s of comunidadTipoGastoList" [value]="s.Id">{{s.TipoGasto}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorTipoGastoId(file)?.length > 0">
                      {{ getErrorTipoGastoId(file) }}
                    </mat-label>
                  </div>
                  <div fxFlex=25 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarControlExpensas">
                    <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorServicioGastoId(file)?.length > 0 ? '-25px' : '0px')}">
                      <mat-label *ngIf="!file.IsComunidadTipoGastoServicioSearching">Servicio*</mat-label>
                      <mat-label *ngIf="file.IsComunidadTipoGastoServicioSearching">Cargando...</mat-label>
                      <mat-select [(ngModel)]="file.ServicioGastoId">
                        <mat-option *ngFor="let s of file.ComunidadTipoGastoServicioList" [value]="s.Id">{{s.Nombre}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorServicioGastoId(file)?.length > 0">
                      {{ getErrorServicioGastoId(file) }}
                    </mat-label>
                  </div>
                  <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorFechaVencimiento(file)?.length > 0 ? '-25px' : '0px')}">
                      <mat-label [ngStyle]="{'color': (getErrorFechaVencimiento(file)?.length > 0 ? '#E53935' : 'auto')}">Fecha Vencimiento*</mat-label>
                      <input matInput [matDatepicker]="fechaVencimientoPicker" [(ngModel)]="file.FechaVencimiento" (click)="fechaVencimientoPicker.open()">
                      <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoPicker">
                      </mat-datepicker-toggle>
                      <mat-datepicker #fechaVencimientoPicker></mat-datepicker>
                    </mat-form-field>
                    <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorFechaVencimiento(file)?.length > 0">
                      {{ getErrorFechaVencimiento(file) }}
                    </mat-label>
                  </div>

                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorDetalle(file)?.length > 0 ? '-25px' : '0px')}">
                      <mat-label [ngStyle]="{'color': (getErrorDetalle(file)?.length > 0 ? '#E53935' : 'auto')}">Detalle*</mat-label>
                      <input matInput [(ngModel)]="file.Detalle" maxlength="100">
                    </mat-form-field>
                    <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorDetalle(file)?.length > 0">
                      {{ getErrorDetalle(file) }}
                    </mat-label>
                  </div>
                  <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorAlicuotaIvaId(file)?.length > 0 ? '-25px' : '0px')}">
                      <mat-label *ngIf="!isAlicuotaIvaSearching">Alicuota IVA*</mat-label>
                      <mat-label *ngIf="isAlicuotaIvaSearching">Cargando...</mat-label>
                      <mat-select [(ngModel)]="file.AlicuotaIvaId" (selectionChange)="onAlicuotaIvaSelect(file)">
                        <mat-option *ngFor="let s of alicuotaIvaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorAlicuotaIvaId(file)?.length > 0">
                      {{ getErrorAlicuotaIvaId(file) }}
                    </mat-label>
                  </div>
                  <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorMonedaId(file)?.length > 0 ? '-25px' : '0px')}">
                      <mat-label *ngIf="!isMonedaSearching">Moneda*</mat-label>
                      <mat-label *ngIf="isMonedaSearching">Cargando...</mat-label>
                      <mat-select [(ngModel)]="file.Moneda" (selectionChange)="onMonedaSelect(file)">
                        <mat-option *ngFor="let s of monedaList" [value]="s">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorMonedaId(file)?.length > 0">
                      {{ getErrorMonedaId(file) }}
                    </mat-label>
                  </div>

                  <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorImporteBase(file)?.length > 0 ? '-25px' : '0px')}">
                      <mat-label [ngStyle]="{'color': (getErrorImporteBase(file)?.length > 0 ? '#E53935' : 'auto')}">Importe Base*</mat-label>
                      <input matInput type="number" [(ngModel)]="file.ImporteBase" (change)="calcularImportes(file)">
                    </mat-form-field>
                    <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorImporteBase(file)?.length > 0">
                      {{ getErrorImporteBase(file) }}
                    </mat-label>
                  </div>
                  <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%;">
                      <mat-label>Importe Impuestos*</mat-label>
                      <input matInput type="number" [(ngModel)]="file.ImporteAlicuotaIva" (change)="calcularImportes(file)">
                    </mat-form-field>
                    <!-- <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorImporteAlicuotaIva(file)?.length > 0">
                      {{ getErrorImporteAlicuotaIva(file) }}
                    </mat-label> -->
                  </div>
                  <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorImporte(file)?.length > 0 ? '-25px' : '0px')}">
                      <mat-label [ngStyle]="{'color': (getErrorImporte(file)?.length > 0 ? '#E53935' : 'auto')}">Importe Total*</mat-label>
                      <input matInput type="number" [(ngModel)]="file.Importe" (change)="calcularImportes(file)">
                    </mat-form-field>
                    <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorImporte(file)?.length > 0">
                      {{ getErrorImporte(file) }}
                    </mat-label>
                  </div>

                  <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                    <!-- <mat-expansion-panel [expanded]="true" hideToggle="true"> -->
                      <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorObservacion(file)?.length > 0 ? '-25px' : '0px')}">
                        <mat-label [ngStyle]="{'color': (getErrorObservacion(file)?.length > 0 ? '#E53935' : 'auto')}">Observación</mat-label>
                        <textarea matInput [(ngModel)]="file.Observacion" maxlength="300"></textarea>
                      </mat-form-field>
                      <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorObservacion(file)?.length > 0">
                        {{ getErrorObservacion(file) }}
                      </mat-label>
                    <!-- </mat-expansion-panel> -->
                  </div>

                  <ng-container *ngIf="tenantFeatureFlags?.HabilitarControlCaja">

                    <hr width="100%">

                    <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" style="margin: 10px 0px;">

                      <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                        <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorTipoMovimientoId(file)?.length > 0 ? '-25px' : '0px')}">
                          <mat-label *ngIf="!isTipoMovimientoSearching">Tipo de Movimiento*</mat-label>
                          <mat-label *ngIf="isTipoMovimientoSearching">Cargando...</mat-label>
                          <mat-select [(ngModel)]="file.TipoMovimientoId">
                            <mat-option *ngFor="let s of tipoMovimientoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorTipoMovimientoId(file)?.length > 0">
                          {{ getErrorTipoMovimientoId(file) }}
                        </mat-label>
                      </div>
                      <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                        <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorCantidadCuotas(file)?.length > 0 ? '-25px' : '0px')}">
                          <mat-label>Cantidad de Cuotas*</mat-label>
                          <input matInput type="number" [(ngModel)]="file.CantidadCuotas" (keyup.enter)="onGuardar()">
                        </mat-form-field>
                        <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorCantidadCuotas(file)?.length > 0">
                          {{ getErrorCantidadCuotas(file) }}
                        </mat-label>
                      </div>
                      <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                        <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorCantidadCuotas(file)?.length > 0 ? '-25px' : '0px')}">
                          <mat-label>{{(file.CantidadCuotas > 1) ? 'Fecha de Inicio de Cuota' : 'Fecha Movimiento'}}*</mat-label>
                          <input matInput [matDatepicker]="fechaInicioCuotaPicker" [(ngModel)]="file.FechaInicioCuota" (click)="fechaInicioCuotaPicker.open()">
                          <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaInicioCuotaPicker">
                          </mat-datepicker-toggle>
                          <mat-datepicker #fechaInicioCuotaPicker></mat-datepicker>
                        </mat-form-field>
                        <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorFechaInicioCuota(file)?.length > 0">
                          {{ getErrorFechaInicioCuota(file) }}
                        </mat-label>
                      </div>

                      <ng-container *ngIf="(file.CantidadCuotas > 1)">

                        <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                          <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorDiasRepeticionCuotas(file)?.length > 0 ? '-25px' : '0px')}">
                            <mat-label>Periodicidad de Cuotas (en días)*</mat-label>
                            <input matInput type="number" [(ngModel)]="file.DiasRepeticionCuotas" (keyup.enter)="onGuardar()">
                          </mat-form-field>
                          <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorDiasRepeticionCuotas(file)?.length > 0">
                            {{ getErrorDiasRepeticionCuotas(file) }}
                          </mat-label>
                        </div>
                        <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                          <mat-form-field appearance="outline" style="width: 100%;" [ngStyle]="{'margin-bottom': (getErrorPorcentajeAjusteCuota(file)?.length > 0 ? '-25px' : '0px')}">
                            <mat-label>Porcentaje de Ajuste*</mat-label>
                            <input matInput type="number" [(ngModel)]="file.PorcentajeAjusteCuota" (keyup.enter)="onGuardar()">
                          </mat-form-field>
                          <mat-label style="width: 100%; color: #E53935; font-size: 75%;" *ngIf="getErrorPorcentajeAjusteCuota(file)?.length > 0">
                            {{ getErrorPorcentajeAjusteCuota(file) }}
                          </mat-label>
                        </div>
                        <div fxFlex=25 fxFlex.xs=100 class="flex-item" *ngIf="(file.PorcentajeAjusteCuota > 0)">
                          <mat-checkbox class="text-style" [(ngModel)]="file.AplicarAjusteIncremental" (keyup.enter)="onGuardar()" color="primary">
                            Aplicar el porcentaje de ajuste <br/>de forma incremental en cada cuota
                          </mat-checkbox>
                        </div>

                      </ng-container>

                    </div>

                  </ng-container>

                </div>

              </ng-container>

            </ng-container>

          </mat-expansion-panel>

        </div>

        <div fxLayout="row stretch" class="zb-readonly" *ngIf="hasAnalyzed && item?.Adjuntos != null && item?.Adjuntos.length > 0">

          <div fxFlex=100 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true" style="padding-top: 10px; background-color: indianred;">
              <mat-label><b>MONTOS TOTALES:</b></mat-label>
              <br/>
              <ng-container>
                <mat-label *ngFor="let item of totalesSeleccionados" style="margin: 10px 0px 0px 10px;">
                  <b>{{item.key}}:</b> <span style="margin-left: 5px;">{{item.value | number: '1.2-2'}}</span> <br/>
                </mat-label>
              </ng-container>
            </mat-expansion-panel>
          </div>

        </div>

      </mat-expansion-panel>

    </div>

  </mat-card-content>

  <mat-card-actions>
    <div class="flex-actions">
      <button mat-raised-button (click)="onAnalizar()" [disabled]="isProcessing()" color="primary" class="zb-button" *ngIf="!hasAnalyzed && item?.Adjuntos != null && item?.Adjuntos.length > 0">
        {{isAnalyzing ? 'Analizando...' : 'Analizar Documentos'}}
      </button>
      <button mat-raised-button (click)="onGuardar()" [disabled]="isProcessing()" color="primary" class="zb-button" *ngIf="hasAnalyzed && item?.Adjuntos != null && item?.Adjuntos.length > 0">
        {{isSaving ? 'Guardando...' : 'Guardar'}}
      </button>
      <button mat-raised-button (click)="onCancel()" color="warn">Cancelar</button>
      <button mat-raised-button (click)="onClean()" [disabled]="isProcessing()" *ngIf="item?.Adjuntos != null && item?.Adjuntos.length > 0">
        {{isResetting ? 'Limpiando...' : 'Reiniciar'}}
      </button>
    </div>
  </mat-card-actions>

</mat-card>
